// extracted by mini-css-extract-plugin
export default {"label":"PunchupPercentPieChart_label__RgYYN"};